import { CrabPromo } from './containers/crab-promo';

export default [
    {
        index: true,
        element: <CrabPromo />,
    },
];
